export default __webpack_public_path__ + "static/media/cancer-care-hero.6757203b.png";